import axios from 'axios';

// Use same origin for API calls - works on any domain (preview, custom domain, etc.)
const API = `${window.location.origin}/api`;
const HTTP_UNAUTHORIZED = 401;

const api = axios.create({
  baseURL: API,
});

// Add auth token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('zipai_access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auto-refresh on 401
api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    if (error.response?.status === HTTP_UNAUTHORIZED && !original._retry && !original.url?.includes('/auth/')) {
      original._retry = true;
      const refreshToken = localStorage.getItem('zipai_refresh_token');
      if (refreshToken) {
        try {
          const { data } = await axios.post(`${API}/auth/refresh`, { refresh_token: refreshToken });
          if (data.access_token) {
            localStorage.setItem('zipai_access_token', data.access_token);
            original.headers.Authorization = `Bearer ${data.access_token}`;
            return api(original);
          }
        } catch { /* refresh failed */ }
      }
      localStorage.removeItem('zipai_access_token');
      localStorage.removeItem('zipai_refresh_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
export { API };
